const PropTypes = require('prop-types');
const React = require('react');
const classNames = require('classnames');

// Example:
//   <Tabs>
//     <Tabs.Tab name="First Tab" id="first-tab">
//       First tab content
//     </Tabs.Tab>
//     <Tabs.Tab name="Second Tab" id="second-tab">
//       Second tab content
//     </Tabs.Tab>
//   </Tabs>

class Tabs extends React.Component {
  constructor(props) {
    super(props);
    this.window = props.window || window; // injection for testing
    this.state = {
      activeTab: this.defaultActiveTab(),
    };
  }

  componentDidMount() {
    this.onNewActiveTab();

    $(this.window).on('hashchange', () => {
      let tab;
      if (this.urlAnchor) {
        tab = this.tabWithId(this.urlAnchor);
      } else {
        // If you hit the back button, changing from /foo#bar to an
        // anchor-less URL, we want to take you back to the first tab.
        tab = this.tabs[0];
      }
      if (tab && !this.isActive(tab)) {
        this.setActiveTab(tab);
      }
    });
  }

  componentDidUpdate() {
    this.onNewActiveTab();
  }

  onNewActiveTab() {
    const tab = this.state.activeTab;
    if (tab.props.tabDidShow) {
      tab.props.tabDidShow(tab);
    }
  }

  setActiveTab(tab) {
    this.setState({ activeTab: tab });
  }

  defaultActiveTab() {
    // if url anchor is a valid rendered tab, use it; otherwise show first tab
    const tab = this.tabWithId(this.urlAnchor);
    return (tab || this.tabs[0]);
  }

  isActive(tab) {
    return tab.props.id === this.state.activeTab.props.id;
  }

  handleClickTab(tab) {
    if (this.isActive(tab)) { return; }

    this.setActiveTab(tab);
    if (this.props.updateUrlHash) {
      this.window.location.hash = tab.props.id;
    }
  }

  tabWithId(id) {
    return this.tabs.find((tab) => tab.props.id === id);
  }

  get tabs() {
    return this.props.children.filter((tab) => tab);
  }

  get urlAnchor() {
    return this.window.location.hash.slice(1);
  }

  renderNavTab(tab) {
    return (
      <li
        className="nav-tabs__tab"
        key={tab.props.id}
        onClick={() => this.handleClickTab(tab)}
        data-nav-tab={tab.props.id}
      >
        <a className={classNames({ active: this.isActive(tab) })}>
          {tab.props.name}
        </a>
      </li>
    );
  }

  renderPanel(tab) {
    return (
      <div className={classNames('tab-pane', { active: this.isActive(tab) })} key={tab.props.id} data-tab={tab.props.id}>
        {tab}
      </div>
    );
  }

  render() {
    return (
      <div className={this.props.className}>
        <ul className="nav-tabs">
          {this.tabs.map((tab) => this.renderNavTab(tab))}
        </ul>
        <div className="tab-content">
          {this.tabs.map((tab) => this.renderPanel(tab))}
        </div>
      </div>
    );
  }
}

Tabs.propTypes = {
  children: PropTypes.node.isRequired,
  updateUrlHash: PropTypes.bool,
  className: PropTypes.string,
};

Tabs.defaultProps = {
  updateUrlHash: false,
};

Tabs.Tab = ({ children }) => <div>{children}</div>;

Tabs.Tab.propTypes = {
  name: PropTypes.node.isRequired,
  id: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  tabDidShow: PropTypes.func,
};


module.exports = Tabs;



// WEBPACK FOOTER //
// ./javascripts/components/shared/tabs.jsx